/**
 * Textos do módulo de Estoque: transferências entre galpões e os ajustes
 * diretos (editar/excluir) liberados apenas para o login master da plataforma.
 */
export const TEXTOS_ESTOQUE_TRANSFERENCIA = {
  pt: {
    Galpão: "Galpão",
    "Galpão de origem": "Galpão de origem",
    "Galpão de destino": "Galpão de destino",
    "Transfira produtos e seus cadastros entre galpões, com aprovação, trânsito e recebimento rastreáveis.":
      "Transfira produtos e seus cadastros entre galpões, com aprovação, trânsito e recebimento rastreáveis.",
    "Informe galpões de origem e destino diferentes.": "Informe galpões de origem e destino diferentes.",
    "Não foi possível carregar os galpões.": "Não foi possível carregar os galpões.",
    "Não foi possível carregar os produtos do galpão de origem.":
      "Não foi possível carregar os produtos do galpão de origem.",
    "Nenhum galpão disponível para este login.": "Nenhum galpão disponível para este login.",
    Lote: "Lote",
    "Nova quantidade": "Nova quantidade",
    "Ajustar saldo de estoque": "Ajustar saldo de estoque",
    "Ajustar movimentação de estoque": "Ajustar movimentação de estoque",
    "Ajuste exclusivo do login master da plataforma.": "Ajuste exclusivo do login master da plataforma.",
    "Salvar ajuste": "Salvar ajuste",
    "Excluir saldo": "Excluir saldo",
    "Excluir movimentação": "Excluir movimentação",
    "Saldo ajustado com sucesso.": "Saldo ajustado com sucesso.",
    "Saldo excluído com sucesso.": "Saldo excluído com sucesso.",
    "Movimentação ajustada com sucesso.": "Movimentação ajustada com sucesso.",
    "Movimentação excluída com sucesso.": "Movimentação excluída com sucesso.",
    "Editar transferência": "Editar transferência",
    "Excluir transferência": "Excluir transferência",
    "Transferência atualizada com sucesso.": "Transferência atualizada com sucesso.",
    "Transferência excluída com sucesso.": "Transferência excluída com sucesso.",
    "Não foi possível excluir a transferência.": "Não foi possível excluir a transferência.",
    "Não foi possível salvar a transferência.": "Não foi possível salvar a transferência.",
    "Ajuste feito pelo login master da plataforma.": "Ajuste feito pelo login master da plataforma.",
  },
  en: {
    Galpão: "Warehouse",
    "Galpão de origem": "Source warehouse",
    "Galpão de destino": "Destination warehouse",
    "Transfira produtos e seus cadastros entre galpões, com aprovação, trânsito e recebimento rastreáveis.":
      "Transfer products and their records between warehouses, with traceable approval, transit and receipt.",
    "Informe galpões de origem e destino diferentes.": "Choose different source and destination warehouses.",
    "Não foi possível carregar os galpões.": "The warehouses could not be loaded.",
    "Não foi possível carregar os produtos do galpão de origem.":
      "The products of the source warehouse could not be loaded.",
    "Nenhum galpão disponível para este login.": "No warehouse available for this login.",
    Lote: "Batch",
    "Nova quantidade": "New quantity",
    "Ajustar saldo de estoque": "Adjust stock balance",
    "Ajustar movimentação de estoque": "Adjust stock movement",
    "Ajuste exclusivo do login master da plataforma.": "Adjustment restricted to the platform master login.",
    "Salvar ajuste": "Save adjustment",
    "Excluir saldo": "Delete balance",
    "Excluir movimentação": "Delete movement",
    "Saldo ajustado com sucesso.": "Balance adjusted successfully.",
    "Saldo excluído com sucesso.": "Balance deleted successfully.",
    "Movimentação ajustada com sucesso.": "Movement adjusted successfully.",
    "Movimentação excluída com sucesso.": "Movement deleted successfully.",
    "Editar transferência": "Edit transfer",
    "Excluir transferência": "Delete transfer",
    "Transferência atualizada com sucesso.": "Transfer updated successfully.",
    "Transferência excluída com sucesso.": "Transfer deleted successfully.",
    "Não foi possível excluir a transferência.": "The transfer could not be deleted.",
    "Não foi possível salvar a transferência.": "The transfer could not be saved.",
    "Ajuste feito pelo login master da plataforma.": "Adjustment made by the platform master login.",
  },
  es: {
    Galpão: "Almacén",
    "Galpão de origem": "Almacén de origen",
    "Galpão de destino": "Almacén de destino",
    "Transfira produtos e seus cadastros entre galpões, com aprovação, trânsito e recebimento rastreáveis.":
      "Transfiera productos y sus registros entre almacenes, con aprobación, tránsito y recepción trazables.",
    "Informe galpões de origem e destino diferentes.": "Indique almacenes de origen y destino diferentes.",
    "Não foi possível carregar os galpões.": "No se pudieron cargar los almacenes.",
    "Não foi possível carregar os produtos do galpão de origem.":
      "No se pudieron cargar los productos del almacén de origen.",
    "Nenhum galpão disponível para este login.": "No hay almacenes disponibles para este acceso.",
    Lote: "Lote",
    "Nova quantidade": "Nueva cantidad",
    "Ajustar saldo de estoque": "Ajustar saldo de stock",
    "Ajustar movimentação de estoque": "Ajustar movimiento de stock",
    "Ajuste exclusivo do login master da plataforma.": "Ajuste exclusivo del acceso máster de la plataforma.",
    "Salvar ajuste": "Guardar ajuste",
    "Excluir saldo": "Eliminar saldo",
    "Excluir movimentação": "Eliminar movimiento",
    "Saldo ajustado com sucesso.": "Saldo ajustado correctamente.",
    "Saldo excluído com sucesso.": "Saldo eliminado correctamente.",
    "Movimentação ajustada com sucesso.": "Movimiento ajustado correctamente.",
    "Movimentação excluída com sucesso.": "Movimiento eliminado correctamente.",
    "Editar transferência": "Editar transferencia",
    "Excluir transferência": "Eliminar transferencia",
    "Transferência atualizada com sucesso.": "Transferencia actualizada correctamente.",
    "Transferência excluída com sucesso.": "Transferencia eliminada correctamente.",
    "Não foi possível excluir a transferência.": "No se pudo eliminar la transferencia.",
    "Não foi possível salvar a transferência.": "No se pudo guardar la transferencia.",
    "Ajuste feito pelo login master da plataforma.": "Ajuste realizado por el acceso máster de la plataforma.",
  },
  "zh-CN": {
    Galpão: "仓库",
    "Galpão de origem": "来源仓库",
    "Galpão de destino": "目标仓库",
    "Transfira produtos e seus cadastros entre galpões, com aprovação, trânsito e recebimento rastreáveis.":
      "在仓库之间调拨产品及其档案，审批、在途和收货全程可追溯。",
    "Informe galpões de origem e destino diferentes.": "请选择不同的来源仓库和目标仓库。",
    "Não foi possível carregar os galpões.": "无法加载仓库列表。",
    "Não foi possível carregar os produtos do galpão de origem.": "无法加载来源仓库的产品。",
    "Nenhum galpão disponível para este login.": "该账号没有可用的仓库。",
    Lote: "批次",
    "Nova quantidade": "新数量",
    "Ajustar saldo de estoque": "调整库存余额",
    "Ajustar movimentação de estoque": "调整库存变动",
    "Ajuste exclusivo do login master da plataforma.": "仅平台主账号可执行此调整。",
    "Salvar ajuste": "保存调整",
    "Excluir saldo": "删除余额",
    "Excluir movimentação": "删除变动",
    "Saldo ajustado com sucesso.": "余额调整成功。",
    "Saldo excluído com sucesso.": "余额删除成功。",
    "Movimentação ajustada com sucesso.": "变动调整成功。",
    "Movimentação excluída com sucesso.": "变动删除成功。",
    "Editar transferência": "编辑调拨单",
    "Excluir transferência": "删除调拨单",
    "Transferência atualizada com sucesso.": "调拨单更新成功。",
    "Transferência excluída com sucesso.": "调拨单删除成功。",
    "Não foi possível excluir a transferência.": "无法删除该调拨单。",
    "Não foi possível salvar a transferência.": "无法保存该调拨单。",
    "Ajuste feito pelo login master da plataforma.": "由平台主账号执行的调整。",
  },
} as const;
